export enum DateTypeEnum {
  Predefined = 'Predefined',
  Custom = 'Custom',
  Created = 'CREATED',
  Closed = 'CLOSED',
  Settled = 'SETTLED',
}
